/**
 * Component added to top panel products
 */
class TopPanelComponent {
    constructor() {
        this.typeId = TopPanelComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return true;
    }
}
TopPanelComponent.id = 2059;
export default TopPanelComponent;
//# sourceMappingURL=TopPanelComponent.js.map